import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Pack\GetPackByIdController::__invoke
* @see app/Http/Controllers/Pack/GetPackByIdController.php
* @route '/api/pack/{pack}'
*/
const GetPackByIdController = (args: { pack: string | number | { id: string | number } } | [pack: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetPackByIdController.url(args, options),
    method: 'get',
})

GetPackByIdController.definition = {
    methods: ["get","head"],
    url: '/api/pack/{pack}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Pack\GetPackByIdController::__invoke
* @see app/Http/Controllers/Pack/GetPackByIdController.php
* @route '/api/pack/{pack}'
*/
GetPackByIdController.url = (args: { pack: string | number | { id: string | number } } | [pack: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { pack: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { pack: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            pack: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        pack: typeof args.pack === 'object'
        ? args.pack.id
        : args.pack,
    }

    return GetPackByIdController.definition.url
            .replace('{pack}', parsedArgs.pack.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Pack\GetPackByIdController::__invoke
* @see app/Http/Controllers/Pack/GetPackByIdController.php
* @route '/api/pack/{pack}'
*/
GetPackByIdController.get = (args: { pack: string | number | { id: string | number } } | [pack: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetPackByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Pack\GetPackByIdController::__invoke
* @see app/Http/Controllers/Pack/GetPackByIdController.php
* @route '/api/pack/{pack}'
*/
GetPackByIdController.head = (args: { pack: string | number | { id: string | number } } | [pack: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetPackByIdController.url(args, options),
    method: 'head',
})

export default GetPackByIdController